export interface IChatInfo {
  id: string
  role: ChatRole // 聊天角色
  question: string // 用户输入的问题,如果角色是AI答案，同样要加入question
  answer?: string // ai答案 图像为id
  answerStatus?: 'ing' | 'success' | 'failed'
  count?: number // 轮询次数
}

export enum ChatRole {
  user = 'user',
  ai = 'aiRobot',
}

export const ChatListContainerID = 'ai-chat-list-container'
export const ChatListID = 'ai-chat-list-box'
